import { render, staticRenderFns } from "./editMayoristaForm.vue?vue&type=template&id=98397a3e&scoped=true"
import script from "./editMayoristaForm.vue?vue&type=script&lang=js"
export * from "./editMayoristaForm.vue?vue&type=script&lang=js"
import style0 from "./editMayoristaForm.vue?vue&type=style&index=0&id=98397a3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98397a3e",
  null
  
)

export default component.exports